<script>
	import userService from "../user/service.svelte.js";

	let queryString = new URLSearchParams(
		document.location.search.substring(1),
	);
	let otac = queryString.get("otac");
	let next_page = queryString.get("next");

	userService
		.otac_validate(otac)
		.then((user) => {
			window.location.href = next_page ? `${next_page}` : "/dashboard";
		})
		.catch((errors) => {
			window.location.href = `/login?errors=${errors.message}`;
			return false;
		});
</script>
